/**
 * Dashboard JavaScript - N6 AI Trading Platform
 * Handles sidebar, theme switching, and Chart.js initialization
 */

document.addEventListener('DOMContentLoaded', function() {
  // ============================================
  // SIDEBAR FUNCTIONALITY
  // ============================================
  const sidebar = document.getElementById('sidebar');
  const sidebarToggle = document.getElementById('sidebarToggle');
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileOverlay = document.querySelector('.mobile-menu-overlay');
  const close = document.querySelector('.close');
  const topbarRight = document.querySelector('.topbar__right');
  const sidebarFooter = document.querySelector('.sidebar__footer');
  const topbarToggles = topbarRight ? topbarRight.querySelectorAll('.toggle-switch') : [];
  let sidebarTogglesContainer = null;

  // Desktop: Toggle sidebar expanded/collapsed
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', function() {
      sidebar.classList.toggle('is-expanded');
      localStorage.setItem('sidebarExpanded', sidebar.classList.contains('is-expanded'));
    });

  }

  // Mobile: Open/close sidebar
  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function() {
      sidebar.classList.add('is-open');
      mobileOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
  }

  function ensureSidebarTogglesContainer() {
    if (!sidebarFooter) return null;
    if (sidebarTogglesContainer) return sidebarTogglesContainer;

    sidebarTogglesContainer = sidebarFooter.querySelector('.sidebar__toggles');
    if (!sidebarTogglesContainer) {
      sidebarTogglesContainer = document.createElement('div');
      sidebarTogglesContainer.className = 'sidebar__toggles';
      sidebarFooter.insertBefore(sidebarTogglesContainer, sidebarFooter.firstChild);
    }
    return sidebarTogglesContainer;
  }

  function moveTopbarToggles() {
    if (!topbarRight || !topbarToggles.length) return;
    if (window.innerWidth <= 991) {
      const container = ensureSidebarTogglesContainer();
      if (!container) return;
      topbarToggles.forEach(function(t) { container.appendChild(t); });
    } else {
      topbarToggles.forEach(function(t) { topbarRight.insertBefore(t, topbarRight.firstChild); });
    }
  }

  // Close mobile menu
  function closeMobileMenu() {
    sidebar.classList.remove('is-open');
    mobileOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }
  if (close) {
    close.addEventListener('click', closeMobileMenu);
  }

  moveTopbarToggles();
  window.addEventListener('resize', function() {
    moveTopbarToggles();
  });

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Set active sidebar link based on current page
  (function() {
    var currentPage = window.location.pathname.split('/').pop() || 'dashboard.html';
    var links = document.querySelectorAll('.sidebar__menu-link');
    links.forEach(function(link) {
      link.classList.remove('is-active');
      if (link.getAttribute('href') === currentPage) {
        link.classList.add('is-active');
      }
    });
  })();

  // ============================================
  // THEME SWITCHING
  // ============================================
  const body = document.body;
  const themeToggle = document.getElementById('themeToggle');
  const sidebarThemeToggle = document.getElementById('sidebarThemeToggle');

  // Placeholder for chart update function (defined later)
  let updateChartsTheme = function() {};

  // Update sidebar theme label
  function updateThemeLabel(isLight) {
    const themeLabel = document.querySelector('.sidebar__theme-label');
    if (themeLabel) {
      themeLabel.textContent = isLight ? 'Light Mode' : 'Dark Mode';
    }
  }

  // Theme: checked = light mode, unchecked = dark mode
  function setTheme(isLight) {
    if (isLight) {
      body.classList.remove('theme-dark');
      body.classList.add('theme-light');
      localStorage.setItem('dashboardTheme', 'light');
      if (themeToggle) themeToggle.checked = true;
      if (sidebarThemeToggle) sidebarThemeToggle.checked = true;
    } else {
      body.classList.remove('theme-light');
      body.classList.add('theme-dark');
      localStorage.setItem('dashboardTheme', 'dark');
      if (themeToggle) themeToggle.checked = false;
      if (sidebarThemeToggle) sidebarThemeToggle.checked = false;
    }
    updateThemeLabel(isLight);
    // Update charts colors if they exist
    if (typeof updateChartsTheme === 'function') {
      updateChartsTheme();
    }
  }

  // Theme toggle checkbox - checked = light mode, unchecked = dark mode
  if (themeToggle) {
    themeToggle.addEventListener('change', function() {
      setTheme(this.checked); // checked = light
    });
  }

  // Sidebar theme toggle (syncs with topbar toggle)
  if (sidebarThemeToggle) {
    sidebarThemeToggle.addEventListener('change', function() {
      setTheme(this.checked); // checked = light
    });
  }

  // Restore saved theme (default = dark)
  const savedTheme = localStorage.getItem('dashboardTheme');
  if (savedTheme === 'light') {
    setTheme(true); // light
  } else {
    setTheme(false); // dark (default)
  }

  // ============================================
  // CHARTS INITIALIZATION (Chart.js)
  // ============================================

  var hasDashboardCharts = !!document.getElementById('balanceChart') ||
    !!document.getElementById('performanceChart') ||
    !!document.getElementById('allocationChart');
  if (!hasDashboardCharts) return;

  // Check if Chart.js is loaded only when dashboard charts are present
  if (typeof Chart === 'undefined') return;

  // Get theme colors
  function getThemeColors() {
    const isDark = body.classList.contains('theme-dark');
    return {
      text: isDark ? '#FFFFFF' : '#111827',
      textSecondary: isDark ? '#9CA3AF' : '#6B7280',
      gridColor: isDark ? 'rgba(255, 255, 255, 0.08)' : '#E5E7EB',
      primary: '#0077B6',
      primaryLight: '#48CAE4',
      success: '#22C55E',
      warning: '#F59E0B',
      error: '#EF4444'
    };
  }

  let balanceChart, performanceChart, allocationChart;

  // Balance Donut Chart with bubble labels plugin
  const balanceChartEl = document.getElementById('balanceChart');
  if (balanceChartEl) {
    // Custom plugin to draw bubble labels at segment ends
    const bubbleLabelsPlugin = {
      id: 'bubbleLabels',
      afterDraw(chart) {
        const { ctx, chartArea } = chart;
        const meta = chart.getDatasetMeta(0);
        const dataset = chart.data.datasets[0];

        if (!meta.data.length) return;

        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const outerRadius = meta.data[0].outerRadius;
        const bubbleRadius = 24;

        meta.data.forEach((arc, index) => {
          const angle = (arc.startAngle + arc.endAngle) / 2;
          const x = centerX + Math.cos(angle) * (outerRadius + 8);
          const y = centerY + Math.sin(angle) * (outerRadius + 8);

          // Draw bubble
          ctx.save();
          ctx.beginPath();
          ctx.arc(x, y, bubbleRadius, 0, Math.PI * 2);
          ctx.fillStyle = '#FFFFFF';
          ctx.shadowColor = 'rgba(0, 0, 0, 0.15)';
          ctx.shadowBlur = 8;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 2;
          ctx.fill();
          ctx.restore();

          // Draw text
          ctx.save();
          ctx.font = 'bold 11px Inter, sans-serif';
          ctx.fillStyle = '#111827';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(dataset.data[index] + '%', x, y);
          ctx.restore();
        });
      }
    };

    balanceChart = new Chart(balanceChartEl, {
      type: 'doughnut',
      data: {
        labels: ['Available', 'Invested' ],
        datasets: [{
          data: [ 32.9, 67.1,],
          backgroundColor: ['#48CAE4', '#FFFFFF'],
          borderWidth: 0,
          cutout: '60%',
          spacing: 4,
          borderRadius: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
          padding: 35
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return context.label + ': ' + context.parsed + '%';
              }
            }
          }
        }
      },
      plugins: [bubbleLabelsPlugin]
    });
  }

  // Portfolio Performance Line Chart
  const performanceChartEl = document.getElementById('performanceChart');
  if (performanceChartEl) {
    const colors = getThemeColors();
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const data = [38000, 42000, 39000, 45000, 52000, 58000, 55000, 62000, 68000, 75000, 82000, 88000];

    performanceChart = new Chart(performanceChartEl, {
      type: 'line',
      data: {
        labels: months,
        datasets: [{
          data: data,
          borderColor: colors.success,
          backgroundColor: function(context) {
            const chart = context.chart;
            const {ctx, chartArea} = chart;
            if (!chartArea) return null;
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, 'rgba(34, 197, 94, 0.3)');
            gradient.addColorStop(1, 'rgba(34, 197, 94, 0)');
            return gradient;
          },
          fill: true,
          tension: 0.4,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: colors.success,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function(context) {
                return '$' + context.parsed.y.toLocaleString();
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: colors.textSecondary,
              font: {
                size: 11
              }
            }
          },
          y: {
            grid: {
              color: colors.gridColor
            },
            ticks: {
              color: colors.textSecondary,
              font: {
                size: 11
              },
              callback: function(value) {
                return '$' + (value / 1000) + 'K';
              }
            }
          }
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        }
      }
    });
  }

  // Stock Allocation Doughnut Chart
  const allocationChartEl = document.getElementById('allocationChart');
  if (allocationChartEl) {
    allocationChart = new Chart(allocationChartEl, {
      type: 'doughnut',
      data: {
        labels: ['Tesla', 'Apple', 'Google', 'Other'],
        datasets: [{
          data: [33.7, 24.4, 22.8, 19.3],
          backgroundColor: ['#0077B6', '#00A8E8', '#48CAE4', '#90E0EF'],
          borderWidth: 0,
          cutout: '60%'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
  }

  // Risk Exposure - Dynamic CSS bubbles
  const riskBubbles = {
    container: document.querySelector('.risk-bubbles'),
    legendContainer: document.querySelector('.risk-legend'),

    // Default colors for bubbles (by index)
    colors: ['#F59E0B', '#F97316', '#22C55E', '#0077B6', '#8B5CF6'],

    // Default labels
    labels: ['Medium Risk', 'Low Risk', 'High Risk', 'Very Low Risk', 'Critical Risk'],

    // Size range (relative to container)
    minSizePercent: 10,
    maxSizePercent: 60,



    // Render bubbles from data array
    // Data format: [50.3, 16.9, 32.8] or [{value: 50.3, label?: 'Medium', color?: '#F59E0B'}]
    render: function(data) {
      if (!this.container) return;

      // Normalize data format - support both array of numbers and array of objects
      const normalizedData = data.map((item, index) => {
        if (typeof item === 'number') {
          return { value: item, label: this.labels[index], color: this.colors[index] };
        }
        return {
          value: item.value,
          label: item.label || this.labels[index],
          color: item.color || this.colors[index]
        };
      });

      // Clear existing bubbles
      this.container.innerHTML = '';
      if (this.legendContainer) this.legendContainer.innerHTML = '';

      // Sort by value descending (largest = index 0)
      const sortedData = [...normalizedData].sort((a, b) => b.value - a.value);

      // Find max value for relative sizing
      const maxValue = Math.max(...sortedData.map(d => d.value));

      // Create bubbles
      sortedData.forEach((item, index) => {
        const bubble = document.createElement('div');
        bubble.className = 'risk-bubble';

        // Calculate size relative to max value
        // const sizePercent = this.minSizePercent +
        //   ((item.value / maxValue) * (this.maxSizePercent - this.minSizePercent));
        // console.log(this.maxSizePercent);
        // console.log(this.minSizePercent);
        const sizePercent = item.value + 10;
        console.log(sizePercent);
        // Apply styles
        bubble.style.width = sizePercent + '%';
        bubble.style.aspectRatio = '1';
        bubble.style.backgroundColor = item.color;

        // Value label
        const valueSpan = document.createElement('span');
        valueSpan.className = 'risk-bubble__value';
        valueSpan.innerHTML = item.value + '<small>%</small>';
        bubble.appendChild(valueSpan);

        this.container.appendChild(bubble);
      });

      // Create legend (in original order, not sorted)
      if (this.legendContainer) {
        normalizedData.forEach((item) => {
          const legendItem = document.createElement('div');
          legendItem.className = 'risk-legend__item';

          const dot = document.createElement('span');
          dot.className = 'risk-legend__dot';
          dot.style.backgroundColor = item.color;

          const label = document.createElement('span');
          label.textContent = item.label;

          legendItem.appendChild(dot);
          legendItem.appendChild(label);
          this.legendContainer.appendChild(legendItem);
        });
      }
    }
  };

  // Initialize with default data (just percentages)
  const defaultRiskData = [50.3, 19.9, 28.8];
  riskBubbles.render(defaultRiskData);

  // Expose to global scope
  window.riskBubbles = riskBubbles;

  // Usage examples:
  // Simple array of percentages:
  // riskBubbles.render([50.3, 16.9, 32.8]);
  //
  // With custom labels:
  // riskBubbles.render([
  //   { value: 50.3, label: 'Medium Risk' },
  //   { value: 16.9, label: 'Low Risk' },
  //   { value: 32.8, label: 'High Risk' }
  // ]);

  // Update charts when theme changes
  updateChartsTheme = function() {
    const colors = getThemeColors();

    if (performanceChart) {
      performanceChart.options.scales.x.ticks.color = colors.textSecondary;
      performanceChart.options.scales.y.ticks.color = colors.textSecondary;
      performanceChart.options.scales.y.grid.color = colors.gridColor;
      performanceChart.update();
    }
  };
});
